import {PropsWithChildren, useContext, useEffect, useState} from 'react';
import {useSubscription} from 'react-stomp-hooks';

import {CODELOGIC_UI_PATH} from 'src/config';
import {WorkspaceContext} from 'src/context';
import {NoDataPlaceholder} from 'src/components/NoDataPlaceholder';
import {getMaterializedViewId} from 'src/api/materializedViews';
import {MaterializedViewStatusMessage} from 'src/types';

import './styles.css';

const WORKING_PATH = CODELOGIC_UI_PATH + '/Working.gif';

export const WorkingOnIt = ({gotData = () => {}, hadData = () => {}, children}: PropsWithChildren<{gotData: () => void, hadData?: () => void}>) => {
  const {currentWorkspace} = useContext(WorkspaceContext);
  const [hasMatView, setHasMatView] = useState(true);

  useSubscription('/topic/materializedViews', (message) => {
    const response: MaterializedViewStatusMessage = JSON.parse(message.body);
    if (response.workspaceId && response.workspaceId === currentWorkspace?.id) {
      const materializedView = response.materializedView;
      if (materializedView.buildEnded) {
        gotData();
      }
    }
  });


  const initData = async () => {
    if (currentWorkspace?.materializedViewDefinition && !currentWorkspace.materializedViewDefinition.primary) {
      const materializedViewId = await getMaterializedViewId(currentWorkspace.materializedViewDefinition.id);
      if (materializedViewId.status === 'success' && materializedViewId.data) {
        setHasMatView(true);
        hadData();
      } else {
        setHasMatView(false);
      }
    } else if (currentWorkspace?.materializedViewDefinition && currentWorkspace.materializedViewDefinition.primary) {
      hadData();
    }
  };

  useEffect(() => {
    initData();
  }, []);

  return (
    <>
      {currentWorkspace && !currentWorkspace.primary && !hasMatView &&
      <div className='WorkingOnIt'>
        <h1>We&apos;re working on it</h1>
        <h3 className='Sub'>Check back soon!</h3>
        <img src={WORKING_PATH} className='Gear'/>
      </div>
      }
      {currentWorkspace && currentWorkspace.primary && !hasMatView &&
        <NoDataPlaceholder>
          {children}
        </NoDataPlaceholder>
      }
    </>);
};
